"use client";

import { useTranslations } from "next-intl";
import { TrustStars } from "@/components/TrustStars";
import { GoogleStars } from "@/components/GoogleStars";
import { useExperimentVariant } from "@/hooks/useExperimentVariant";
import { site } from "@/lib/site";

// Hero social-proof rating row (stars + "{count}+ reizigers geholpen"), driven by
// the `hero-delay-banner` presence experiment. Server-renders the control (visible)
// so it stays the SEO/LCP default, then hides itself for the "banner" variant after
// the flag loads — at which point HeroDelayBanner shows the urgency strip instead.
// The stars also follow the `reviews-google-snippet` experiment: gold Google stars
// are the default, the "green" holdback variant shows green Trustpilot-style squares.
export function HeroRating() {
  const t = useTranslations("Hero");
  const variant = useExperimentVariant("hero-delay-banner");
  const green = useExperimentVariant("reviews-google-snippet") === "green";

  if (variant === "banner") return null;

  return (
    <div className="flex items-center gap-2.5 sm:gap-3">
      {green ? (
        <TrustStars squareClassName="size-4 sm:size-6" />
      ) : (
        <GoogleStars starClassName="size-4 sm:size-6" />
      )}
      <span className="whitespace-nowrap text-[13px] font-bold text-white sm:text-[15px]">
        {t("ratingLabel", { count: site.helped })}
      </span>
    </div>
  );
}
